import React from "react";
import { sortBy } from "lodash";
import Button from "@mui/material/Button";

import { useBids } from "../../../hooks/useBids";
import { BIDS } from "../../../constants";

export const BidPicker: React.FC = () => {
  const { validBids, makeBid, iAmActiveBidder } = useBids();

  if (validBids === undefined) {
    return <div className="text-emerald-200">Loading...</div>;
  }

  if (!iAmActiveBidder) {
    return (
      <div className="text-emerald-100 text-lg font-medium animate-pulse">
        Waiting for other players to bid...
      </div>
    );
  }

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-6 text-white">Make a Bid</h2>
      <div className="flex flex-wrap items-center justify-center gap-3 max-w-2xl">
        {sortBy(
          BIDS.filter((b) => !b.ruferSubBid),
          ({ points }) => points
        ).map((bid) => {
          const isValid = validBids.map(({ slug }) => slug).includes(bid.slug);
          return (
            <Button
              key={bid.slug}
              variant={isValid ? "contained" : "outlined"}
              className="!rounded-full"
              disabled={!isValid}
              onClick={() => makeBid({ bid })}
              sx={{
                backgroundColor: isValid ? '#059669' : 'transparent',
                borderColor: isValid ? '#059669' : 'rgba(255,255,255,0.3)',
                color: isValid ? 'white' : 'rgba(255,255,255,0.5)',
                '&:hover': {
                  backgroundColor: isValid ? '#047857' : 'rgba(255,255,255,0.1)',
                  borderColor: isValid ? '#047857' : 'rgba(255,255,255,0.5)',
                },
                '&:disabled': {
                  borderColor: 'rgba(255,255,255,0.15)',
                  color: 'rgba(255,255,255,0.3)',
                },
              }}
            >
              {bid.name}
            </Button>
          );
        })}
      </div>
    </div>
  );
};
